import { DefaultTheme } from "styled-components";
import { Colors, colors } from "./colors";
import { ContainerStyles, containerStyles } from "./containerStyles";
import { TextStyles, textStyles } from "./textStyles";

export const theme: DefaultTheme = {
	colors,
	textStyles,
	containerStyles,
};

declare module "styled-components" {
	export interface DefaultTheme {
		colors: Colors;
		textStyles: TextStyles;
		containerStyles: ContainerStyles;
	}
}
